import { render, staticRenderFns } from "./ShareBtn.vue?vue&type=template&id=0baba260&scoped=true"
import script from "./ShareBtn.vue?vue&type=script&lang=js"
export * from "./ShareBtn.vue?vue&type=script&lang=js"
import style0 from "./style.scss?vue&type=style&index=0&id=0baba260&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0baba260",
  null
  
)

export default component.exports